/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileSchemaOut
 */
export interface FileSchemaOut {
    /**
     * 
     * @type {string}
     * @memberof FileSchemaOut
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FileSchemaOut
     */
    s3key?: string;
    /**
     * 
     * @type {string}
     * @memberof FileSchemaOut
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof FileSchemaOut
     */
    contentType?: string;
    /**
     * 
     * @type {string}
     * @memberof FileSchemaOut
     */
    extension?: string;
    /**
     * 
     * @type {Date}
     * @memberof FileSchemaOut
     */
    uploadedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof FileSchemaOut
     */
    fileSize?: number;
    /**
     * 
     * @type {number}
     * @memberof FileSchemaOut
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof FileSchemaOut
     */
    width?: number;
    /**
     * 
     * @type {string}
     * @memberof FileSchemaOut
     */
    url?: string;
}

/**
 * Check if a given object implements the FileSchemaOut interface.
 */
export function instanceOfFileSchemaOut(value: object): boolean {
    return true;
}

export function FileSchemaOutFromJSON(json: any): FileSchemaOut {
    return FileSchemaOutFromJSONTyped(json, false);
}

export function FileSchemaOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileSchemaOut {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        's3key': json['s3key'] == null ? undefined : json['s3key'],
        'fileName': json['file_name'] == null ? undefined : json['file_name'],
        'contentType': json['content_type'] == null ? undefined : json['content_type'],
        'extension': json['extension'] == null ? undefined : json['extension'],
        'uploadedAt': json['uploaded_at'] == null ? undefined : (new Date(json['uploaded_at'])),
        'fileSize': json['file_size'] == null ? undefined : json['file_size'],
        'height': json['height'] == null ? undefined : json['height'],
        'width': json['width'] == null ? undefined : json['width'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function FileSchemaOutToJSON(value?: FileSchemaOut | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        's3key': value['s3key'],
        'file_name': value['fileName'],
        'content_type': value['contentType'],
        'extension': value['extension'],
        'uploaded_at': value['uploadedAt'] == null ? undefined : ((value['uploadedAt'] as any).toISOString()),
        'file_size': value['fileSize'],
        'height': value['height'],
        'width': value['width'],
        'url': value['url'],
    };
}

